import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaDireccion } from '../_direccion.js';

/**
 * Vive dentro del grupo `_direccion`, así que el guardián ya se aplicó y esta ruta no repite
 * ninguna verificación. Es la razón de ser de los grupos.
 *
 * El componente llega a pedido, como el de usuarios y por la misma razón: arrastra
 * `@tanstack/query` y las tres piezas del módulo, y el operario no debe descargar nada de eso.
 * Es la adjudicación 41.
 */
export const rutaUmashi = createRoute({
  getParentRoute: () => rutaDireccion,
  path: '/umashi',
  component: lazyRouteComponent(() => import('./umashi-pantalla.js'), 'RutaUmashi'),
});
